import { render, staticRenderFns } from "./CustomTabs.vue?vue&type=template&id=b65a5672&scoped=true"
import script from "./CustomTabs.vue?vue&type=script&lang=js"
export * from "./CustomTabs.vue?vue&type=script&lang=js"
import style0 from "./CustomTabs.vue?vue&type=style&index=0&id=b65a5672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65a5672",
  null
  
)

export default component.exports